import GroupRenewModal from '../components/modals/GroupRenewModal';

export const renewGroup = {
  data() {
    return {
      groupIdsToRenew: [],
      submittingGroupRenew: false,
    };
  },
  methods: {
    onExpirationSelected(date, groupIds) {
      const vm = this;
      vm.submittingGroupRenew = true;
      if (groupIds.length === 1) {
        this.$store.dispatch('renewGroup', { uugid: groupIds[0], expiration: date })
          .finally(() => {
            vm.groupIdsToRenew = [];
            vm.submittingGroupRenew = false;
          });
      }
      // The parent component should handle `groupExpirationSelected` event so the form data can be cleared correctly.
    },
  },
  components: {
    GroupRenewModal,
  },
};



// WEBPACK FOOTER //
// ./src/util/renew-group-mixin.js